export const BREAKPOINTS = {
  mobile_small: '480px',
  mobile: '768px',
  tablet: '1024px',
};
